import { render, staticRenderFns } from "./Lgx02660610869022462836974.vue?vue&type=template&id=78b2636a&"
import script from "./Lgx02660610869022462836974.vue?vue&type=script&lang=js&"
export * from "./Lgx02660610869022462836974.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports